export default __webpack_public_path__ + "maps-examples-source-custom-vector-960-ddedd2c2fa161709c59b6af73453493b.png";